const getItem = async (key) => {
  const result = await sessionStorage.getItem(key)
  return result ? JSON.parse(result) : null
}

const setItem = async (key, value) => {
  await sessionStorage.setItem(key, JSON.stringify(value))
}

const removeItem = async (key) => {
  await sessionStorage.removeItem(key)
}

export default {
  getItem,
  setItem,
  removeItem
}
